<div class="row">
  <form [formGroup]="form">
    <div class="col-12 form-group">
      <label>{{ 'user.email' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['email']"
      ></app-input-with-error>
    </div>
    <div class="col-12 form-group">
      <label>{{ 'user.given_name' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['given_name']"
      ></app-input-with-error>
    </div>
    <div class="col-12 form-group">
      <label>{{ 'user.family_name' | translate }}</label>
      <app-input-with-error
        [control]="this.form.controls['family_name']"
      ></app-input-with-error>
    </div>
    @if (assignableRoles.length > 1) {
      <div class="col-12 form-group">
        <label>{{ 'user.roles' | translate }}</label>
        <p-multiselect
          [options]="assignableRoles"
          formControlName="roles"
          optionValue="value"
          optionLabel="label"
          [showToggleAll]="false"
          [display]="'chip'"
          class="w-100"
        >
        </p-multiselect>
      </div>
    }
  </form>
  @if (allUserTable) {
    <div class="col-12 form-group">
      <label>{{ 'user.secondaryOrgs' | translate }}</label>
      <p-multiselect
        [options]="orgs"
        [ngModel]="secondaryOrgs"
        optionValue="id"
        [filter]="true"
        filterBy="name"
        [filterPlaceHolder]="'search' | translate"
        [selectionLimit]="MAX_SECONDARY_ORGANIZATIONS"
        [showClear]="true"
        [showToggleAll]="false"
        (ngModelChange)="limitSecondaryOrganizations($event)"
        optionLabel="name"
        class="w-100 md:w-80"
      >
      </p-multiselect>
    </div>
  }
  @if (value.id && value.isSecondaryOrgMember === false) {
    <div class="col-12 mt-2">
      <a (click)="resetPasswordPrompt()">{{
        'user.reset_password?' | translate
      }}</a>
    </div>
  }
</div>
<app-error [error]="error"></app-error>

<ng-template #resetModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'user.reset_password?' | translate }}</h4>
    <button
      type="button"
      class="btn-close"
      (click)="modalRef?.close()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <p>{{ 'user.reset_question' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="modalRef?.close()"
    >
      {{ 'cancel' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="resetPassword()">
      {{ 'user.reset_password' | translate }}
    </button>
  </div>
</ng-template>
